import { BreadcrumbComponent, Loader, Pagination } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ErrorResponse from '../../../../common/assets/images/emptyResponse.svg';
import AppCard from '../../../../common/components/UI/Card/Card';
import { IConnectorList } from '../../../models';
import { AppDispatch, useSelector } from '../../../store/AppStore';
import { getConnectorListRequest } from '../../../store/actions/sagaActions/connectors/ConnectorListSagaActions';
import { ErrorWarning } from '../../../_components/error-warning/ErrorWarning';
import { getConnectorImageDetails } from '../helpers/ConnectorLogoHelper';
import classes from './ConnectorList.module.scss';

/**
 * @method handleServiceData
 * @description returns the selected connector from the list
 * @param connectorListDetails
 * @param id
 * @returns selectedServiceData
 */
export const handleServiceData = (connectorListDetails: IConnectorList[], id: string) => {
  const selectedServiceData = connectorListDetails.find(
    (subarray: { connectorName: string; }) => subarray.connectorName === id
  );
  return (selectedServiceData);
};

const ConnectorList = () => {
  const [page, setPage] = useState<number>(0);
  const [item, setItem] = useState<number>(8);

  const startIndex = page * item;
  const lastIndex = startIndex + item;

  const dispatch = useDispatch<AppDispatch>();

  const { t: translate } = useTranslation();

  const { isLoading, errorMessage, success, connectorListDetails } = useSelector(
    (state) => state.ConnectorListReducer
  );

  /**
   * @method onGetPageNumber
   * @description handles the page number
   * @param page
   */
  const onGetPageNumber = (page: number) => {
    setPage(page);
  };

  /**
   * @method onGetItemsPerPage
   * @description handles the items per page
   * @param item
   */
  const onGetItemsPerPage = (item: number) => {
    setItem(item);
  };

  /**
   * @description slicing for pagination
   */
  const gridPageItem = connectorListDetails.slice(startIndex, lastIndex);

  useEffect(() => {
    dispatch(getConnectorListRequest());
  }, []);

  return (
    <div className={classes.container}>
      <BreadcrumbComponent />
      <Loader show={isLoading} />
      <p className={classes.connector}>{translate('connector_component.connector_lbl')} ({connectorListDetails.length})</p>
      <p className={classes['welcome-text']}>{translate('connector_component.welcome_txt')}</p>
      {!errorMessage && !isLoading && connectorListDetails.length > 0 && (
        <div className={classes['grid-container']}>
          {
            gridPageItem.map((item: IConnectorList) => (
              <AppCard
                className={classes['grid-item']}
                key={item.uuid}
              >
                <Link to={`connectorDetails/${item.connectorName}`} className={classes.link} data-testid="card" onClick={() => handleServiceData(connectorListDetails, item.connectorName)}>
                  <div className={classes.icon}>
                    <div className={classes['header-logo']}>
                      <img src={getConnectorImageDetails(item)} alt="logo" />
                    </div>
                  </div>
                  <div className={classes.title}>
                    {item.connectorName}
                  </div>
                  <div className={classes.desc}>
                    {item.connectorDescription}
                  </div>
                </Link>
              </AppCard>
            ))
          }
        </div>
      )}
      {!errorMessage && !isLoading && connectorListDetails.length > 0 && (
        <Pagination
          itemsPerPage={item}
          currentPageNumber={page}
          numberOfPages={Math.ceil(connectorListDetails.length / item)}
          onCurrentPageNumberChange={onGetPageNumber}
          onItemsPerPageChange={onGetItemsPerPage}
        />
      )}
      {(!isLoading && errorMessage) && <ErrorWarning />}
      {(success && connectorListDetails.length === 0) && (
        <div className={classes['no-record-label']}>
          <p>{translate('connector_component.no_data')}</p>
          <img src={ErrorResponse} alt="error" />
        </div>
      )}
    </div>
  );
};

export default ConnectorList;
